import { Component } from '@angular/core'

@Component({
    selector: 'ContactLayout',
    template: `
      <router-outlet></router-outlet>
  `
})

export class ContactLayoutComponent { }
